/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLaborCostLogRequest } from '../../models/create-labor-cost-log-request';
import { LaborCostLogDto } from '../../models/labor-cost-log-dto';

export interface CreateLaborCostLog$Params {
      body: CreateLaborCostLogRequest
}

export function createLaborCostLog(http: HttpClient, rootUrl: string, params: CreateLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDto>> {
  const rb = new RequestBuilder(rootUrl, createLaborCostLog.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostLogDto>;
    })
  );
}

createLaborCostLog.PATH = '/v0/laborCostLogs/{id}';
